
if(__webpack_require__.federation.instance){

	__webpack_require__.federation.runtime.init(__webpack_require__.federation.initOptions);
}